import React from 'react';
import { IconProps } from '../types';
const MinecraftBrewingStand: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="3" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(227, 218, 118, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(227, 218, 118, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(217, 204, 63, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(217, 204, 63, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(82, 82, 82, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(82, 82, 82, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(82, 82, 82, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(82, 82, 82, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(82, 82, 82, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(49, 49, 49, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(82, 82, 82, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(82, 82, 82, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(212, 183, 58, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(217, 204, 63, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(82, 82, 82, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(210, 131, 51, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(212, 183, 58, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(212, 183, 58, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(210, 131, 51, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(102, 102, 102, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(210, 131, 51, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(212, 183, 58, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(102, 102, 102, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(121, 121, 121, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(202, 99, 42, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(210, 131, 51, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(121, 121, 121, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(121, 121, 121, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(210, 131, 51, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(202, 99, 42, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(121, 121, 121, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(102, 102, 102, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(147, 147, 147, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(202, 99, 42, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(210, 131, 51, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(147, 147, 147, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(102, 102, 102, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(91, 91, 91, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(102, 102, 102, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(102, 102, 102, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
</svg>);
export default MinecraftBrewingStand;